// Guest CRM contact-origin catalogue. Deliberately independent of hms.ns_partners.
// Booking source belongs to a reservation; contact source belongs to the guest.
export const CONTACT_SOURCES = Object.freeze([
  { value: '-101', label: 'Airbnb' },
  { value: '-102', label: 'MMT' },
  { value: '-103', label: 'Google / Website (Direct)' },
  { value: '-104', label: 'Repeat (Direct)' },
  { value: '-105', label: 'Referral / Whatsapp Group' },
  { value: '0', label: 'Walk-In' },
  { value: '-106', label: 'Instagram' },
  { value: '-107', label: 'Other' },
  { value: '1', label: 'Corporate' },
]);

const normalizeSource = value => {
  const text = String(value ?? '').trim().toLowerCase();
  return /^-?\d+$/.test(text) ? text : text.replace(/[^a-z0-9]/g, '');
};
const aliasToCode = new Map();
CONTACT_SOURCES.forEach(source => {
  aliasToCode.set(normalizeSource(source.value), source.value);
  aliasToCode.set(normalizeSource(source.label), source.value);
});
[
  ['makemytrip', '-102'], ['make my trip', '-102'], ['mmt', '-102'],
  ['google', '-103'], ['website', '-103'], ['directwebsite', '-103'],
  ['repeat', '-104'], ['referral', '-105'], ['whatsapp', '-105'],
  ['walkin', '0'], ['walk in', '0'],
].forEach(([alias, code]) => aliasToCode.set(normalizeSource(alias), code));

export const resolveContactSourceCode = value => aliasToCode.get(normalizeSource(value)) || null;
export const getContactSourceLabel = value => {
  const code = resolveContactSourceCode(value);
  return CONTACT_SOURCES.find(item => item.value === code)?.label || 'Not specified';
};
